// extracted by mini-css-extract-plugin
export var documentation = "_kh-1";
export var menu = "_kh-0";